<div class="botao-topo" *ngIf="showbtn">
    <button (click)="voltarAoTopo()" pButton pRipple type="button" icon="pi pi-angle-up"
        class="p-button-rounded"></button>
</div>